export const links = [
    { name: "Home", link: "/" },
    { name: "About Us", link: "#about" },
    { name: "Solutions", link: "#solutions" },
    { name: "Services", link: "#solutions" },
    { name: "Why Choose Us", link: "#why" },
  ];